<template>
  <div id="printParticipants">
    <Printer title="Participants">
      <template v-slot:printContent>
        <div class="ml-2 mr-2">
          <div
            v-if="participants.Unassigned.length > 0"
            class="patrol"
          >
            <div class="critter-title text-danger">
              Unassigned
            </div>
            <participant-bios-patrol
              :participants="participants.Unassigned"
            />
          </div>
          <div
            v-if="participants.Beavers.length > 0"
            class="patrol"
          >
            <div class="critter-title text-danger">
              Beavers
            </div>
            <participant-bios-patrol
              :participants="participants.Beavers"
            />
          </div>
          <div
            v-if="participants.Bobwhites.length > 0"
            class="patrol"
          >
            <div class="critter-title text-danger">
              Bobwhites
            </div>
            <participant-bios-patrol
              :participants="participants.Bobwhites"
            />
          </div>
          <div
            v-if="participants.Eagles.length > 0"
            class="patrol"
          >
            <div class="critter-title text-danger">
              Eagles
            </div>
            <participant-bios-patrol
              :participants="participants.Eagles"
            />
          </div>
          <div
            v-if="participants.Foxes.length > 0"
            class="patrol"
          >
            <div class="critter-title text-danger">
              Foxes
            </div>
            <participant-bios-patrol
              :participants="participants.Foxes"
            />
          </div>
          <div
            v-if="participants.Owls.length > 0"
            class="patrol"
          >
            <div class="critter-title text-danger">
              Owls
            </div>
            <participant-bios-patrol
              :participants="participants.Owls"
            />
          </div>
          <div
            v-if="participants.Bears.length > 0"
            class="patrol"
          >
            <div class="critter-title text-danger">
              Bears
            </div>
            <participant-bios-patrol
              :participants="participants.Bears"
            />
          </div>
          <div
            v-if="participants.Buffaloes.length > 0"
            class="patrol"
          >
            <div class="critter-title text-danger">
              Buffaloes
            </div>
            <participant-bios-patrol
              :participants="participants.Buffaloes"
            />
          </div>
          <div
            v-if="participants.Antelopes.length > 0"
            class="patrol"
          >
            <div class="critter-title text-danger">
              Antelopes
            </div>
            <participant-bios-patrol
              :participants="participants.Antelopes"
            />
          </div>
        </div>
      </template>
    </Printer>
  </div>
</template>

<script>
import Printer from '@/components/_main/printer.vue'
import ParticipantBiosPatrol from '@/components/scouters/participant-bios-patrol.vue'

export default {
  name: 'ParticipantBiosPrint',
  components: {
    Printer,
    ParticipantBiosPatrol
  },
  props: {
    participants: {
      type: Object,
      default: function () {
        return {
          Unassigned: [],
          Beavers: [],
          Bobwhites: [],
          Eagles: [],
          Foxes: [],
          Owls: [],
          Bears: [],
          Buffaloes: [],
          Antelopes: []
        }
      }
    }
  }
}
</script>
